<template>
    <div class="row left-content">
        <div class="col-12">
            <h1>Replenish</h1>
        </div>
        <div class="col-5">
            <div class="white-block">
                <div class="container">
                    <b-form>
                        <div class="row">
                            <div class="col-12">
                                <b-input-group prepend="$" class="mb-2">
                                    <b-form-input
                                        v-model="form.amount"
                                        type="number"
                                        placeholder="Amount"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                        <b-button variant="primary" type="submit" @click.prevent.stop="create()">Replenish</b-button>
                    </b-form>
                    <div class="invalid-feedback d-block" v-for="(error, index) in errors" :key="error">{{ index + ': ' + error }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ServerErrors} from "@/mixins/ServerErrors";
import Swal from "sweetalert2";
export default {
    name: "Payment",
    mixins: [ServerErrors],
    data() {
        return {
            errors: [],
            form: {
                amount: 0
            }
        }
    },
    methods: {
        create() {
            let loader = this.$loading.show();
            this.errors = [];
            window.axios({
                method: 'POST',
                url: '/admin/wallet/project/payment/create',
                data: {
                    amount: parseFloat(this.form.amount)
                }
            })
                .then(() => {
                    this.$router.push({ name: 'admin.project_wallet.view' });
                })
                .catch(error => {
                    this.errors = this.server_errors;
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.data.title ? error.response.data.title: "Something went wrong."
                    });
                })
                .finally(() => {
                    loader.hide();
                });
        }
    }
}
</script>